import React, {lazy} from 'react';
import {IndexRedirect, IndexRoute, Route} from 'react-router';
import sessionStore from 'client/Session/SessionStore';

const SubjectSearch = lazy(() => import('./SubjectSearch/SubjectSearch'));
const AuthoringSubject = lazy(() => import('./AuthoringSubject/AuthoringSubject'));
const AuthoringSubjectWithQuery = lazy(
  () => import('./AuthoringSubject/AuthoringSubjectWithQuery')
);
const AuthoringSubjectEditor = lazy(
  () => import('./AuthoringSubject/AuthoringSubjectEditor/AuthoringSubjectEditor')
);
const GuideEditor = lazy(() => import('./Guides/GuideEditor/GuideEditor'));

export default (
  <Route
    name='Subject Manager'
    path='subjects'
    onEnter={(_nextState, replace) => {
      if (!sessionStore.hasContentManagerAccess()) {
        replace('/dennis/content/queue');
      }
    }}
  >
    <IndexRedirect to='search' />
    <Route component={SubjectSearch} name='Subject Lookup' path='search' />
    <Route component={AuthoringSubject} name='New Subject' path='new'>
      <IndexRoute component={AuthoringSubjectEditor} />
    </Route>
    <Route component={AuthoringSubjectWithQuery}>
      <Route path=':subjectId'>
        <IndexRedirect to='subject' />
        <Route component={AuthoringSubjectEditor} name='Subject Editor' path='subject' />
        <Route component={GuideEditor} path='guides(/:guideId)' />
      </Route>
    </Route>
  </Route>
);
